<template>
  <div class="col-6 d-flex float-start" style="height: 100%">
    <div class="card col px-0 d-flex flex-column">
      <div class="card-header bg-warning text-white">
        <div class="media">
          <div class="media-body h2 text-white">
            {{ projectTypeName }}
          </div>
          <div class="ms-3">
            <search-input
              :placeholder="'ค้นหาด้วยชื่อโครงการ'"
              @search="searchProject"
            ></search-input>
          </div>
        </div>
      </div>
      <div class="card-body list-group">
        <div
          v-for="project in projects"
          :key="project.id"
          class="list-group-item list-project"
        >
          <div class="media">
            <div class="me-2">
              <img :src="project.iconUrl" class="project-icon" />
            </div>
            <div class="media-body">
              <router-link :to="project.route" class="h4">{{
                project.name
              }}</router-link>
              <div class="h5">{{ project.location }}</div>
            </div>
            <div class="me-3 mt-2 h3">{{ project.code }}</div>
          </div>
          <hr />
          <div class="stat">
            <div class="col">
              <h6 class="stat-ttl">Unit ทั้งหมด</h6>
              <div class="count">{{ project.stat.unitCount }}</div>
            </div>
            <div class="col">
              <h6 class="stat-ttl">Unit ที่เปิดใช้งาน</h6>
              <div class="count">{{ project.stat.activeUnitCount }}</div>
            </div>
            <div class="col">
              <h6 class="stat-ttl">จำนวนผู้ใช้</h6>
              <div class="count">{{ project.stat.userCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer list-group-item py-3 list-result">
        <div class="media pt-2">
          <div class="media-body">
            <div class="h4">ผลรวมทุกโครงการ<br /><br /></div>
          </div>
        </div>
        <div class="stat">
          <div class="col">
            <h6 class="stat-ttl"><strong>รวม Unit ทั้งหมด</strong></h6>
            <div class="count">{{ totalStat.unitCount }}</div>
          </div>
          <div class="col">
            <h6 class="stat-ttl">
              <strong>รวม Unit ที่เปิดใช้งาน</strong>
            </h6>
            <div class="count">{{ totalStat.activeUnitCount }}</div>
          </div>
          <div class="col">
            <h6 class="stat-ttl"><strong>รวมจำนวนผู้ใช้</strong></h6>
            <div class="count">{{ totalStat.userCount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from "@/components/helper/SearchInput"
import { isEmpty } from "ramda"

export default {
  components: {
    SearchInput,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    projectTypeName: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      seachKeyword: "",
    }
  },
  computed: {
    projects() {
      if (!this.value) {
        return []
      }

      const projects = !isEmpty(this.seachKeyword)
        ? this.value.projects.filter(
            (project) =>
              project.name.includes(this.seachKeyword) ||
              project.code
                .toUpperCase()
                .includes(this.seachKeyword.toUpperCase()),
          )
        : this.value.projects

      return projects
    },
    totalStat() {
      if (!this.value) {
        return {}
      }

      return this.value.totalStat
    },
  },
  methods: {
    searchProject(keyword) {
      this.seachKeyword = keyword
    },
  },
}
</script>

<style>
.card {
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px 0 rgba(215, 215, 215, 0.7);
}

.list-result {
  border-right: 0px;
  border-left: 0px;
}

.list-project {
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
}

.card .list-group {
  overflow-y: auto;
}

.project-icon {
  width: 40px;
  height: 40px;
  background-color: #eee;
  border-radius: 15px;
  border: #ccc 1px solid;
}

.stat:after {
  display: block;
  content: "";
  clear: both;
}
.stat .col {
  float: left;
  width: 33.33%;
  text-align: center;
  padding: 5px 0 0 0;
  border-right: solid 1px #ccc;
}
.stat .col:last-child {
  border: none;
}
.stat .stat-ttl {
  font-size: 13px;
  margin-bottom: 0;
}
.stat .count {
  font-size: 14px;
  padding: 5px 0;
}
</style>
